module.exports = __webpack_public_path__ + "static/media/user.9d6e0e72.svg";